"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { trackEvent } from "@/lib/analytics";

export default function NotFoundAnalytics() {
  const pathname = usePathname();

  useEffect(() => {
    try {
      trackEvent("page_not_found", {
        path: pathname || (typeof window !== "undefined" ? window.location.pathname : ""),
      });
    } catch (e) {
      // Swallow errors - analytics should not break the page
      // eslint-disable-next-line no-console
      console.error("Failed to track 404 event", e);
    }
  }, [pathname]);

  return null;
}
